import { useEffect, useState } from 'react';

type Line = { text: string; ok?: boolean };

type Props = {
  steps: string[];
  intervalMs?: number;
  onComplete?: () => void;
};

export function TerminalOutput({ steps, intervalMs = 700, onComplete }: Props) {
  const [lines, setLines] = useState<Line[]>([]);

  useEffect(() => {
    setLines([]);
    let i = 0;
    const id = setInterval(() => {
      if (i >= steps.length) {
        clearInterval(id);
        onComplete?.();
        return;
      }
      setLines((prev) => [...prev, { text: steps[i], ok: true }]);
      i++;
    }, intervalMs);
    return () => clearInterval(id);
  }, [steps, intervalMs, onComplete]);

  return (
    <div className="hairline rounded-sm p-4 bg-panel font-mono text-xs text-text-primary min-h-[160px]">
      <div className="text-text-mono-dim mb-2">$ automaton spawn --deploy</div>
      {lines.map((l, i) => (
        <div key={i} className="flex items-center gap-2">
          <span>{l.text}</span>
          <span className="text-green-thrive">✓</span>
        </div>
      ))}
      {lines.length < steps.length && (
        <div className="text-text-mono-dim">
          <span className="blink">▌</span>
        </div>
      )}
    </div>
  );
}
